//interfaces
import { IAcknowledgementPost } from "@/interfaces/activityFeedNotifications";

//components
import ActivityInformationPanel from "../../elements/activityInformationPanel/ActivityInformationPanel";
import ContentTitle from "../../elements/contentTitle/ContentTitle";
import DeletedBanner from "../../elements/deletedComment/DeletedComment";
import ActivityProfileData from "../../elements/activityProfileData/ActivityProfileData";
import AcknowledgementPostTitle from "../../elements/notificationTitle/AcknowledgementPostTitle/AcknowledgementPostTitle";

//hooks
import { AcknowlegementPostConstants, getAcknowledgementPost } from "./AcknowledgementPost.service";

//styling
import "../../../../../css/activityFeed/notifications/acknowledgement-response-activity.scss";



const AcknowledgementPost = ({zIndexNum, isPopOut = false, timeStamp, dateStamp, user, parentList, getOpenOnWebLink, onDownloadReportClick, content, appDetails, acknowledgementType}: IAcknowledgementPost) => {
    const {screenClassName, showDeletedBanner, webLink, downloadReportLink, activityInfo} = getAcknowledgementPost({isPopOut, timeStamp, dateStamp, parentList, getOpenOnWebLink, onDownloadReportClick, content, appDetails});
    const { responseMessage,deletedBannerMessage } = AcknowlegementPostConstants;

    return (
        <div className={`${isPopOut ? "" : "acknowledgement-response-full"} acknowledgement-response notification-wrapper`}>
            <div className="top-row">
                <ActivityProfileData 
                    imageUrl={user.imageUrl}
                    isPopOut={isPopOut}
                    userActivity={acknowledgementType} 
                    timeStamp={timeStamp}
                    dateStamp={dateStamp}
                />
                
                <AcknowledgementPostTitle 
                    content={content} 
                    user={user.name} 
                    isPopOut={isPopOut}
                />
            </div>        

            <ContentTitle 
                zIndexNum={zIndexNum} 
                className={screenClassName} 
                contentTitle={responseMessage} 
                getWebLink={webLink} 
                onDownloadReportClick={downloadReportLink} 
            />
                
            <DeletedBanner 
                isDeleted={showDeletedBanner} 
                message={deletedBannerMessage}
            />

            <ActivityInformationPanel 
                {...activityInfo} 
            />
        </div>
    )
};

export default AcknowledgementPost